
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

import {
  abflussService,
  hauptwerteService,
  stammdatenService
} from "../service";
import { WSAbflusswerte, WSHauptwerteDateRange } from "../interfaces";
import Diagram, { DiagramData } from "@/components/Diagram.vue";
import Loader from "@/components/Loader.vue";
import Table, { Column } from "@/components/Table.vue";
import DateRangeSlider from "@/components/DateRangeSlider.vue";
import DiagramTableSwitch from "@/components/DiagramTableSwitch.vue";
import ErrorDialog from "@/components/ErrorDialog.vue";

@Component({
  components: {
    ErrorDialog,
    Diagram,
    Table,
    Loader,
    DiagramTableSwitch,
    DateRangeSlider
  }
})
export default class Wasserstaende extends Vue {
  @Prop({ required: true })
  id!: number;

  abfluesseTableMeta: Column[] = [
    { text: "Datum", key: "cleardate" },
    { text: "Uhrzeit", key: "time" },
    { text: "Abfluss in m³/s (ungeprüfte Rohdaten)", key: "abfluss" }
  ];

  displayMHQ = false;

  abflusswerte: Array<WSAbflusswerte> | null = null;
  hauptwerte: Array<WSHauptwerteDateRange> = [];
  filteredAbflusswerte: Array<WSAbflusswerte> = [];
  uniqueAbflusswerte: Array<WSAbflusswerte> = [];
  stammdaten: Array<any> = [{ showabflusswerte: 1 }];
  diagramData: Array<any> = [];

  dateRange: (Date | null)[] = [null, null];

  beforeMount() {
    this.getStammdaten(this.id);
    this.getAbflusswerte(this.id);
    this.getHauptwerte(this.id);
  }

  @Watch("dateRange")
  updateFilteredAbflusswerte(event) {
    this.filteredAbflusswerte = [];

    const startDate = event[0];
    const endDate = event[1];

    if (startDate && endDate) {
      startDate.setHours(0);
      startDate.setMinutes(0);
      endDate.setHours(23);
      endDate.setMinutes(59);
    }

    if (event && startDate && endDate) {
      const items = this.abflusswerte?.filter(item => {
        if (item.parseddate) {
          return item.parseddate >= startDate && item.parseddate <= endDate;
        }
      });
      Object.assign(this.filteredAbflusswerte, items);
    }
  }

  removeDuplicates(abflusswerte: WSAbflusswerte[]) {
    const unique: any[] = [];
    const uniqueObject = {};
    for (const i in abflusswerte) {
      const objDate = abflusswerte[i].cleardate;
      uniqueObject[objDate] = abflusswerte[i];
    }
    for (const i in uniqueObject) {
      unique.push(uniqueObject[i]);
    }
    return unique;
  }

  xaxisformatterTooltip(xValue: number) {
    return new Date(xValue).toLocaleString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  }

  yaxisformatter(yValue: number) {
    return parseFloat(yValue.toFixed(3)).toLocaleString();
  }

  getDiagramData(): DiagramData {
    const mnq = this.hauptwerte?.map(e => ({
      x0: new Date(e.start_date),
      x1: new Date(e.end_date),
      y: e.mnq
    })); // MNQ
    const mq = this.hauptwerte?.map(e => ({
      x0: new Date(e.start_date),
      x1: new Date(e.end_date),
      y: e.mq
    }));
    const mhq = this.hauptwerte?.map(e => ({
      x0: new Date(e.start_date),
      x1: new Date(e.end_date),
      y: e.mhq
    }));
    const diagramData = {
      legendText: "Abfluss (ungeprüfte Rohdaten)",
      yLimit: { min: 0 },
      limits: [
        { limit: mnq, legendText: "MNQ (monatlich)" },
        { limit: mq, legendText: "MQ (monatlich) " }
      ],
      list: [{ xValue: 0, yValue: 0.0 }],
      xUnit: "",
      yUnit: "Q in m³/s"
    };

    if (this.displayMHQ) {
      diagramData.limits.push({ limit: mhq, legendText: "MHQ (monatlich)" });
    }

    this.filteredAbflusswerte.map(abflussElement => {
      return diagramData.list.push({
        xValue: Date.parse(abflussElement.datestring),
        yValue: abflussElement.wert
      });
    });

    diagramData.list.shift();

    return diagramData;
  }

  parseDates(ws: WSAbflusswerte): Date {
    return new Date(ws.datestring);
  }

  getAbflusswerte(ms_nr: number) {
    abflussService
      .getMSWSAbflusswerte(ms_nr)
      .then(response => {
        const abflusswerteInit = response.data.map(function(item) {
          const abfluss = item.abfluss;
          item.wert =
            abfluss == null || item.abfluss === "-"
              ? -777
              : parseFloat(abfluss.trim().replaceAll(",", "."));
          return item;
        });

        abflusswerteInit.forEach(element => {
          element.parseddate = this.parseDates(element);
        });

        this.abflusswerte = abflusswerteInit;
        this.filteredAbflusswerte = abflusswerteInit;

        this.uniqueAbflusswerte = this.removeDuplicates(abflusswerteInit);

        this.getDiagramData();
      })
      .catch(e => {
        console.error(e);
      });
  }

  getHauptwerte(ms_nr: number) {
    hauptwerteService
      .getHauptwerteMonat(ms_nr)
      .then(response => {
        this.hauptwerte = response.data;
        this.getDiagramData();
      })
      .catch(e => {
        console.error(e); // TODO error handling
      });
  }

  getStammdaten(ms_nr: number) {
    stammdatenService
      .getStammdaten(ms_nr)
      .then(response => {
        this.stammdaten = response.data;
      })
      .catch(e => {
        console.error(e); // TODO error handling
      });
  }
}

// TODO CHECK DFue == 1 (STAMMDATEN)
